<template>
    <div class="test-view">
        <v-card class="mx-auto normal-card instructions-hg">
            <div class="inst-title">Instructions about the Examination</div>
            <div class="inst-list">
                <div v-html="instructions"></div>
            </div>
        </v-card>
        <div class="test-bottom">
            <div class="bottom-logo">
                <!-- <img src="/img/logo-footer.c1b83f14.png" class="master-logo-btm" /> -->
            </div>
            <div class="test-btn-block TestInstructions">
                <v-btn color="#EFEEEE" class="btn-default left-btn" @click="goBack()">Cancel</v-btn>
                <div class="edit-cust-btnc1">
                    <v-btn
                        color="primary"
                        class="right-btn cust-btn TestInstructionsbtn"
                        @click="customText === 'Start Preview' ? goToTest() : enterFullScreen()"
                    >{{customText}}</v-btn>
                    <v-btn
                        color="primary"
                        class="right-btn cust-btn"
                        v-if="showEditButton"
                        @click="editInstruction()"
                    >Edit</v-btn>
                </div>
            </div>
        </div>
        <AlertBox
            :width="modalwidth"
            :onClose="onClose"
            :component="cComponent"
            :status="status"
            :data="{instructions,persistent}"
        />
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    name: "TestDashboard",
    props: ["instructions", "testData"],
    data: () => ({
        customText: "Start Answering",
        modalwidth: null,
        cComponent: "",
        persistent: false,
        status: false,
        showEditButton: false,
        instructionsToBeEdited: "",
    }),
    mounted() {
        window.scrollTo(0, 0);
        if (
            this.roleIds.CO === this.user.role_id ||
            this.roleIds.ID === this.user.role_id || 
			this.roleIds.ED === this.user.role_id ||
			this.roleIds.TR === this.user.role_id 
        ) {
            this.customText = "Start Preview";
            if (this.testData&& this.testData.test_type == this.TEST_TYPE.CUSTOM && this.roleIds.ED !== this.user.role_id) {
                this.showEditButton = true;
            }
        }
    },
    computed: {
        ...mapState("userStore", ["user"]),
    },
    methods: {
        ...mapActions({
            updateTestInstructions: "testStore/updateTestInstructions",
        }),
        onClose(data) {
            this.status = data.status;
            if (!data.fromAlertBox && data && data.instructions) {
                //this.instructions = data.instructions;
                this.updateInstructions(data.instructions);
            }
        },
        updateInstructions(instructions) {
            let postData = {
                test_id: this.testData.id,
                instructions: instructions,
            };
            this.updateTestInstructions(postData)
                .then((response) => {
                    this.instructions = instructions;
                    this.$toasted.success("Instructions Updated Successfully");
                })
                .catch((err) => {});
        },
        editInstruction() {
            this.cComponent =
                "components/coordinator/Tests/CustomizedTests/AddInstructions";
            this.modalwidth = "1000px";
            this.status = true;
            this.persistent = false;
            this.$forceUpdate();
        },
        enterFullScreen() {
            const elem = document.documentElement; // Get the root element of the document
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            } else if (elem.webkitEnterFullscreen) {
                elem.webkitEnterFullscreen(); // For iOS Safari
            } else if (elem.webkitEnterFullScreen) {
                elem.webkitEnterFullScreen(); // For older versions of iOS Safari
            }
        
            this.goToTest();
        },
        goToTest() {
            let testId = this.$route.params.test_id;
            let route = "test";
            let params = {
                test_id: testId,
                test_institute_id: this.$route.params.test_institute_id,
            };
			const prevRoute = localStorage.getItem('previousRoute')
			 if (
				this.roleIds.TR === this.user.role_id && prevRoute === 'past-tests' 
            ) {
                route = "past-tests-preview";
            } 
            else if (
                this.roleIds.CO === this.user.role_id ||
                this.roleIds.ID === this.user.role_id  || 
				this.roleIds.ED === this.user.role_id || 
				this.roleIds.TR === this.user.role_id 
            ) {
                route = "preview-test";
            } else if(this.testData && this.testData.test_schedule_id){
                params.test_schedule_id = this.testData.test_schedule_id;
                params.student_id = this.user.id;
            }
            this.$router.replace({
                name: route,
                params: params,
            });
        },
        goBack() {
            this.$router.back();
        },
    },
    watch:{
        testData(){
            if (
            this.roleIds.CO === this.user.role_id ||
            this.roleIds.ID === this.user.role_id || 
			this.roleIds.ED === this.user.role_id ||
			this.roleIds.TR === this.user.role_id 
        ) {
            this.customText = "Start Preview";
            if (this.testData&& this.testData.test_type == this.TEST_TYPE.CUSTOM && this.roleIds.ED !== this.user.role_id) {
                this.showEditButton = true;
            }
        }
        }
    }
};
</script>
